import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = Pick<ClientAccount, 'githubRepos' | 'githubReposSingleToken' | 'orderableQualities'>;

export const useGithubData = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query clientAccount {
      clientAccount {
        orderableQualities
        githubRepos {
          id
          personalToken
          pullRequestsSummary
          repoName
          status
        }
        githubReposSingleToken
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['github'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql
        }
      })
  });
};
